/**
 * Ar App
 * This is a simple API for AR App
 *
 * OpenAPI spec version: 1.0.0
 * Contact: csong@lsq.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ProspectDataMigration } from './prospectDataMigration';
import { StageData } from './stageData';

/**
 * A prospect data entity to persist every AR Application's data. It will not persist the redundant information from the corresponded ProspectSchema, it only persit each client/application specific data.
 */
export interface ProspectData { 
    /**
     * A unique GUID for a prospect.
     */
    id: string;
    /**
     * A unique foreign key for the prospect schema.
     */
    prospectSchemaId: string;
    /**
     * BusinessName is an exclusive unique key across all prospects.
     */
    businessName: string;
    /**
     * The GUID of the Exchange company that represents the prospect.
     */
    readonly companyKey?: string;
    /**
     * The feature or product this schema is powering
     */
    schemaType?: string;
    /**
     * Enum value of the application status.
     */
    readonly status?: ProspectData.StatusEnum;
    /**
     * True when deleted, ReadOnly.
     */
    readonly isDeleted?: boolean;
    /**
     * DateTime when created.
     */
    readonly createdDate?: Date;
    /**
     * DateTime when updated.
     */
    readonly updatedDate?: Date;
    /**
     * DateTime when submitted.
     */
    readonly submittedDate?: Date;
    /**
     * Date when a prospect application expires. An expired prospect may need an admin to resend the invitation with a new token/temp password and expiration date.
     */
    readonly expirationDate?: Date;
    /**
     * Coordinator who invited this prospect application.
     */
    readonly coordinatorUserId?: string;
    /**
     * The users that should be notified when the prospectData is updated.
     */
    watchers?: Array<string>;
    /**
     * If the prospect was created with invitation or in other way
     */
    readonly source?: string;
    migration?: ProspectDataMigration;
    /**
     * The invitation token.
     */
    readonly token?: string;
    /**
     * Dictionary of StageData, key: string of StageSchemaId, value: StageData object.
     */
    stages?: { [key: string]: StageData; };
}
export namespace ProspectData {
    export type StatusEnum = 'Created' | 'Invited' | 'Registered' | 'Submitted' | 'Migrated';
    export const StatusEnum = {
        Created: 'Created' as StatusEnum,
        Invited: 'Invited' as StatusEnum,
        Registered: 'Registered' as StatusEnum,
        Submitted: 'Submitted' as StatusEnum,
        Migrated: 'Migrated' as StatusEnum
    };
}